// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';
import {
  IntegrationSummary,
  type IntegrationSummaryWireFormat,
  NewIntegrationSummary,
} from '../IntegrationSummary/IntegrationSummary';

export class QuoteExportAttempt {
  readonly integrationId: string;
  readonly integration: IntegrationSummary;
  readonly state: Enums.JobObjectState;
  readonly reasonCode: Enums.QuoteExportReason;

  constructor(data: { [key: string]: any } = {}) {
    this.integrationId = data.integrationId === undefined ? NIL_UUID : data.integrationId;
    this.integration = NewIntegrationSummary(data.integration);
    this.state = data.state === undefined ? Enums.JobObjectState.Pending : data.state;
    this.reasonCode =
      data.reasonCode === undefined ? Enums.QuoteExportReason.Unknown : data.reasonCode;
  }

  static zero(): QuoteExportAttempt {
    const zeroValues: ExcludeMethodsDeep<QuoteExportAttempt> = {
      integrationId: NIL_UUID,
      integration: IntegrationSummary.zero(),
      state: Enums.JobObjectState.Pending,
      reasonCode: Enums.QuoteExportReason.Unknown,
    };
    return new QuoteExportAttempt(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteExportAttemptWireFormat = {
  integrationId: string;
  integration: IntegrationSummaryWireFormat;
  state: string;
  reasonCode: string;
};

type NewQuoteExportAttemptProps = PartialDeep<QuoteExportAttempt, { recurseIntoArrays: true }>;
export const NewQuoteExportAttempt: (props: NewQuoteExportAttemptProps) => QuoteExportAttempt = (
  props,
) => new QuoteExportAttempt(props);

type NewQuoteExportAttemptFromWireFormatProps = PartialDeep<
  QuoteExportAttemptWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteExportAttemptFromWireFormat: (
  props: NewQuoteExportAttemptFromWireFormatProps,
) => QuoteExportAttempt = (props) => new QuoteExportAttempt(props);
